import { render, staticRenderFns } from "./TabAssess.vue?vue&type=template&id=13fa8f42&"
import script from "./TabAssess.vue?vue&type=script&lang=js&"
export * from "./TabAssess.vue?vue&type=script&lang=js&"
import style0 from "./TabAssess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports